export const getErrorMessage = (error: unknown, fallback = 'Something went wrong. Please try again.'): string =>
  error && typeof error === 'object' && 'message' in error && typeof error.message === 'string'
    ? error.message
    : fallback;
